module.exports = __webpack_public_path__ + "img/ico_chaozhilibao.7ffbe4c9.png";